import { z } from 'zod';

import type { ApiComponentType } from '../types';

export type ApiUserMessageType = ApiComponentType<'UserMessage'>;

export const userMessageZSchema = z.object({
  action: z.string().nullish(),
  content: z.string(),
  id: z.number(),
  title: z.string(),
  actionText: z.string(),
  createdOn: z.string(),
});

export type ParsedUserMessage = z.infer<typeof userMessageZSchema>;
